import { combineReducers } from 'redux'

import items from 'reducers/items'

export default combineReducers({
  items
})


// WEBPACK FOOTER //
// ./app/reducers/index.js